import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatUSD } from "@/lib/marketplaceTerms";

const formatDate = (iso) => { try { return iso ? new Date(iso).toLocaleDateString() : "—"; } catch { return "—"; } };
const METHOD_LABEL = { cash: "Cash", check: "Check", bank_transfer: "Bank transfer", other: "Other" };

export const OfflinePaymentsPanel = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/payments/offline").then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, []);
  if (!rows || rows.length === 0) return null;
  return (
    <div className="mb-8" data-testid="offline-payments-panel">
      <div className="eyebrow">Offline payments</div>
      <div className="text-sm text-[color:var(--text-muted)] mt-1 mb-3">
        Cash, check or bank payments recorded by an admin. They reduce the booking balance but are never held or released by NContro.
      </div>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.tx_id} data-testid={`offline-payment-${r.tx_id}`} className="card-elegant p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-sm">
            <div className="min-w-0">
              <div className="font-serif text-lg">{r.vendor_name} × {r.planner_name}</div>
              <div className="text-xs text-[color:var(--text-muted)] mt-0.5">
                Booking <Link to={`/bookings/${r.booking_id}`} className="font-mono link-underline text-[#1A1A1A]">{r.booking_id}</Link>
                {" · "}{METHOD_LABEL[r.method] || r.method}{r.reference ? ` · ref ${r.reference}` : ""} · recorded {formatDate(r.recorded_at)}
              </div>
              <div className="text-xs mt-1 italic text-[color:var(--text-muted)]" data-testid={`offline-reason-${r.tx_id}`}>“{r.reason}”</div>
            </div>
            <div className="font-serif text-xl shrink-0" data-testid={`offline-amount-${r.tx_id}`}>{formatUSD(r.amount)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
